import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ApplicantsAssociation = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M16 5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1zM10 8H5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zM10 12H5c-.55 0-1 .45-1 1s.45 1 1 1h5c.55 0 1-.45 1-1s-.45-1-1-1zM9 16H5c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1z" />
    <path d="M7 20H2V2h16v4a1 1 0 0 0 2 0V2c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2v18c0 1.103.897 2 2 2h5a1 1 0 1 0 0-2z" />
    <path d="M17 17c2.205 0 4-1.795 4-4s-1.795-4-4-4-4 1.795-4 4 1.795 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM23.895 20.553C23.764 20.29 22.46 18 17 18s-6.764 2.291-6.895 2.553l-.105.21V24h14v-3.236l-.105-.211zM22 22H12v-.665C12.367 20.96 13.633 20 17 20c3.4 0 4.658.979 5 1.326V22z" />
  </SvgIcon>
);

export default ApplicantsAssociation;
